import { Stack, Button, Typography } from "@mui/material";

import { Link } from "react-router-dom";

const ManagementNav = (props) => {
  const pathUrl = props?.location?.pathname || "";

  const navItems = [
    {
      path: "printPicklists",
      label: "Print Picklists",
    },
    {
      path: "mergeOrders",
      label: "Merge Orders",
    },
    {
      path: "generateInvoices",
      label: "Generate Invoices",
    },
    {
      path: "finalizeInvoices",
      label: "Finalize Invoices",
    },
    {
      path: "emailInvoices",
      label: "Email Invoices",
    },
    {
      path: "exportInvoices",
      label: "Export Invoices",
    },
    {
      path: "exportOrderlists",
      label: "Export Orderlist",
    },
    {
      path: "orderFollowup",
      label: "Order Follow-up",
    },
  ];

  return (
    <Stack direction="row" spacing={1} justifyContent="center" useFlexGap flexWrap="wrap" sx={{ mb: 2, gap: 1 }}>
      {navItems.map((item, index) =>
        pathUrl.includes(item.path) ? (
          <Button key={index} variant="contained" color="primary">
            <Typography variant="subtitle2" className="text-white">
              {item.label}
            </Typography>
          </Button>
        ) : (
          <Link key={index} to={`/${item.path}`}>
            <Button variant="contained" color="inherit">
              <Typography variant="subtitle2" color="black">
                {item.label}
              </Typography>
            </Button>
          </Link>
        ),
      )}
    </Stack>
  );
};

export default ManagementNav;
